import React from "react";
import { Link } from "react-router-dom";

const YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="es-footer">
      <div className="es-footer__inner">
        <div>
          <Link to="/" className="es-brand" style={{ color: "#fff", marginBottom: "1rem" }}>
            <span className="es-brand__mark" aria-hidden="true">ES</span>
            <span className="es-brand__name">
              <strong>Edu</strong><span style={{ color: "var(--es-sand-400)" }}>Special</span>
            </span>
          </Link>
          <p>
            Specialist therapy and inclusive education, delivered by one
            coordinated team so families do not have to hold it together
            themselves.
          </p>
        </div>

        <div>
          <h2>Explore</h2>
          <ul>
            <li><Link to="/program">Programs</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/about">About us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h2>Support</h2>
          <ul>
            <li><Link to="/donate">Make a donation</Link></li>
            <li><Link to="/signup">Create an account</Link></li>
            <li><Link to="/signin">Sign in</Link></li>
          </ul>
        </div>

        <div>
          <h2>Visit</h2>
          <ul>
            <li>Hamra Street</li>
            <li>Beirut, Lebanon</li>
            <li>Mon–Thu, 08:00–17:00</li>
            <li>Fri, 08:00–14:00</li>
          </ul>
        </div>
      </div>

      <div className="es-footer__base">
        <p style={{ margin: 0 }}>© {YEAR} EduSpecial. All rights reserved.</p>
        <p style={{ margin: 0 }}>
          Step-free access throughout · Low-stimulation waiting room on request
        </p>
      </div>
    </footer>
  );
}
